import React from "react";
var SearchHeader = function SearchHeader(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "resource-center__search__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "resource-center__search__container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "resource-center__search__header__title like-h2",
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
};
export default SearchHeader;